import {
   HealthcareFacilityLocation,
   HealthcareFacilityLocationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { healthcareOrganizationTranslationKeys } from '../../../../../translations';

type HealthcareFacilityLocationUpdateFormLoaderRenderProps = {
   healthcareFacilityLocation: HealthcareFacilityLocation;
};

type HealthcareFacilityUnitUpdateFormLoaderProps = {
   readonly healthcareFacilityLocationId: number;
   readonly children: (renderProps: HealthcareFacilityLocationUpdateFormLoaderRenderProps) => JSX.Element;
};

export const HealthcareFacilityLocationUpdateFormLoader = (
   props: HealthcareFacilityUnitUpdateFormLoaderProps
): JSX.Element => {
   const {
      data: healthcareFacilityLocation,
      loading: healthcareFacilityLocationLoading,
      error: healthcareFacilityLocationError,
   } = useCqrsGet<HealthcareFacilityLocation>(() => {
      const query = new HealthcareFacilityLocationQuery();
      query.id = Slot.of(props.healthcareFacilityLocationId);
      return query;
   });

   if (healthcareFacilityLocationLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareFacilityLocationError) {
      return (
         <Message
            testId={'failedToFetchHealthcareFacilityLocation'}
            label={healthcareOrganizationTranslationKeys.failedToFetchHealthcareFacilityLocation}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareFacilityLocation: healthcareFacilityLocation,
   });
};
